import React from "react";
import RadioButtons from "../atoms/RadioButtons";
import Dropdown from "../atoms/Dropdown";

const RadioOrSelect = ({
  placeholder,
  options,
  onSelect,
  optionKey,
  multiOptionKey = null,
  selectedOption,
  isMandatory,
  t,
  labelKey,
  dropdownStyle = {},
  isDependent = false,
  disabled = false,
  optionCardStyles,
  isPTFlow=false,
  isDropDown = false
}) => {
  return (
    <React.Fragment>
      {options?.length < 3 && !isDropDown ? (
        <RadioButtons
          selectedOption={selectedOption}
          options={options}
          optionsKey={optionKey}
          multiOptionKey={multiOptionKey}
          isDependent={isDependent}
          disabled={disabled}
          onSelect={onSelect}
          labelKey={labelKey}
          isPTFlow={isPTFlow}
          t={t}
        />
      ) : (
        <Dropdown
          isMandatory={isMandatory}
          selected={selectedOption}
          style={dropdownStyle}
          optionKey={optionKey}
          multiOptionKey={multiOptionKey}
          option={options}
          select={onSelect}
          t={t}
          disable={disabled}
          optionCardStyles={optionCardStyles}
          placeholder={placeholder}
        />
      )}
    </React.Fragment>
  );
};

export default RadioOrSelect;
